import React from 'react';

const WhatsAppIcon = ({ className = 'w-4 h-4' }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    className={className}
  >
    <path d="M19.05 4.94A9.86 9.86 0 0 0 12.03 2C6.57 2 2.12 6.43 2.12 11.9c0 1.75.46 3.45 1.34 4.94L2 22l5.3-1.4a9.9 9.9 0 0 0 4.72 1.2h.01c5.46 0 9.9-4.44 9.9-9.9a9.8 9.8 0 0 0-2.88-6.96Zm-7.02 15.2h-.01a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3.14.83.84-3.07-.2-.31a8.2 8.2 0 0 1-1.27-4.37c0-4.52 3.67-8.2 8.2-8.2a8.2 8.2 0 0 1 8.2 8.2c0 4.53-3.67 8.2-8.14 8.2Zm4.5-6.14c-.25-.13-1.46-.72-1.68-.8-.23-.08-.39-.13-.56.13-.17.25-.64.8-.79.96-.15.17-.29.19-.54.06-.25-.12-1.04-.38-1.98-1.22-.74-.66-1.24-1.47-1.39-1.72-.15-.25-.02-.39.11-.52.12-.12.25-.29.37-.43.12-.15.17-.25.25-.42.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.77-1.83-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.08s.89 2.42 1.02 2.59c.12.17 1.75 2.67 4.23 3.74.59.25 1.05.4 1.41.52.59.18 1.12.15 1.54.09.47-.07 1.46-.6 1.67-1.18.21-.57.21-1.06.15-1.18-.06-.11-.23-.17-.48-.29Z" />
  </svg>
);

export default WhatsAppIcon;
